/**
 * T: type of the values that will be suggested
 * O: type of the prop used from objects of type P
 * P: type of objects
 */
export class Suggestion<T, O, P> {
    readonly key: string;
    readonly display: string;
    readonly operators: Operator<O>[];
    readonly values: T[];
    readonly propSupply: (P) => O;

    constructor(key: string, display: string, operators: Operator<O>[], values: T[], propSupply: (P) => O) {
        this.key = key;
        this.display = display;
        this.operators = operators;
        this.values = values;
        this.propSupply = propSupply;
    }

    buildPredicate(operator: Operator<O>, value: string): (P) => boolean {
        return (p: P) => {
            let prop = this.propSupply(p);
            return operator.compare(prop, value);
        };
    }
}

export class Operator<T> {
    readonly key: string;
    readonly display: string;
    readonly compare: (expected: T, actual: string) => boolean;

    constructor(key: string, display: string, compare: (expected: T, actual: string) => boolean) {
        this.key = key;
        this.display = display;
        this.compare = compare;
    }
}

export class Segment<T, O, P> {
    readonly suggestion: Suggestion<T, O, P>;
    operator: Operator<T> | null;
    value: string;

    constructor(suggestion: Suggestion<T, O, P>) {
        this.suggestion = suggestion;
        this.operator = null;
        this.value = '';
    }
    
    public clone(): Segment<T,O,P> {
        const ret  = new Segment<T,O,P>(this.suggestion);
        ret.operator = this.operator;
        ret.value = this.value;
        return ret;
    }
}

export class SearchEvent<T, O, P> {
    readonly segments: Segment<T, O, P>[];
    readonly search: string;

    constructor(segments: Segment<T, O, P>[], search: string) {
        this.segments = segments;
        this.search = search;
    }
}